import React, { useState, ChangeEvent, FC, useEffect } from 'react';

interface DailyMobileDataProps {
  alarm: any;
  onChange: (newMetrics: any) => void;
}

const DailyMobileData: FC<DailyMobileDataProps> = ({ alarm, onChange }) => {
  const [dataLimitMb, setDataLimitMb] = useState<number>(0);

  useEffect(() => {
    if (alarm !== "") {
      setDataLimitMb(Math.abs(alarm.daily_data_limit_mb)); // Ensure positive
    } else {
      setDataLimitMb(0);
    }
  }, [alarm]);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = Math.abs(parseInt(event.target.value, 10));
    setDataLimitMb(value);
    onChange({ type: "DailyMobileData", daily_data_limit_mb: value });
  };

  return (
    <div className="input-group col-md-4 col-sm-4" style={{ padding: 0 }}>
      <div className="d-flex align-items-center">
      <i className="las la-sim-card icon-report"   />
        <input
        className="form-control input-sm"
        name="mobile_data_limit"
        value={dataLimitMb}
        min={0}
        placeholder="Daily Mobile Data Limit"
        type="number"
        size={10}
        maxLength={20}
        onChange={handleInputChange}
        /*onKeyDown={(e) => {
          // Prevent minus key
          if (e.key === '-' || e.key === 'Subtract') {
            e.preventDefault();
          }
        }}*/
      />
      <span style={{ paddingLeft: 10 }} className="input-group-addon">MB</span>
      </div>
    </div>
  );
};

export default DailyMobileData;
